"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uniqMessage;

let extract = item => item.message || item;

function uniqMessage(msg, i, list) {
  let idx = -1;
  msg = extract(msg);
  list.some((item, ii) => {
    if (extract(item) === msg) {
      idx = ii;
      return true;
    }
  });
  return idx === i;
}